// src/theme.ts
import { createTheme } from '@mui/material/styles';

// サイト共通のデザイントークン
export const brand = {
  ink: '#111418',
  inkSub: '#3D434B',
  muted: '#6B7078',
  line: '#E3E5E8',
  lineDark: 'rgba(255, 255, 255, 0.14)',
  paper: '#FFFFFF',
  paperAlt: '#F5F6F7',
  dark: '#0D0F12',
  accent: '#45B6AF',
  accentText: '#1E7871',
  fontSans: "'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Hiragino Sans', Meiryo, sans-serif",
  fontMono: "'JetBrains Mono', SFMono-Regular, Menlo, Consolas, monospace",
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: brand.fontSans,
  },
});

export default theme;
